/* eslint-disable no-underscore-dangle */
import lodashSortBy from 'lodash/sortBy';

import { WorkspaceChainFragment } from '@/sections/Overview/Chains/__generated__/fragments.generated';
import { WorkspaceModelFragment } from '@/sections/Overview/Models/__generated__/fragments.generated';
import moment from 'moment';

import { getChainWithDeployments } from '../../Chains/utils';
import { getModelWithVersions } from '../../Models/utils';
import { productionStatusSortOrder } from '../../constants';
import { SortBy } from '../../types';

function getEntitiesWithDeployments(
  entities: Array<WorkspaceModelFragment | WorkspaceChainFragment>,
) {
  return Object.values(entities).filter((entity) => {
    if (entity.__typename === 'ModelType') {
      return getModelWithVersions(entity);
    }

    if (entity.__typename === 'ChainType') {
      return getChainWithDeployments(entity);
    }

    return false;
  });
}

function sortEntities(
  entities: Array<WorkspaceModelFragment | WorkspaceChainFragment>,
  sortBy: SortBy,
) {
  switch (sortBy) {
    case SortBy.RECENTLY_ACTIVE:
      return lodashSortBy(entities, (entity) => moment(entity.lastActivity).valueOf()).reverse();
    case SortBy.PRODUCTION:
      return lodashSortBy(entities, [
        (entity) => {
          const primary =
            entity.__typename === 'ModelType' ? entity.primaryVersion : entity.primaryDeployment;

          if (!primary) return productionStatusSortOrder.length;
          // NOTE: context - https://basetenlabs.slack.com/archives/C091NHC1NSJ/p1752490715354759?thread_ts=1752267604.391379&cid=C091NHC1NSJ
          if (!primary.isPrimary) return productionStatusSortOrder.length - 3.5;

          return productionStatusSortOrder.indexOf(
            primary.__typename === 'ModelVersionType'
              ? primary.currentModelDeploymentStatus.status
              : primary.status,
          );
        },
        (entity) => -moment(entity.lastActivity).valueOf(),
      ]);
    case SortBy.CREATED:
      return lodashSortBy(entities, (entity) => moment(entity.created).valueOf()).reverse();
    default:
      return lodashSortBy(entities, (entity) => moment(entity.lastActivity).valueOf()).reverse();
  }
}

export { getEntitiesWithDeployments, sortEntities };
